import {RestClient} from "../../util/RestClient";
import {Config} from "../../util/Config";
import Request from "../../model/Request";
import Response from "../../model/Response";
import PagedResponse from "../../entities/PagedResponse";
import Pagination from "../../entities/Pagination";
import ArticleStockResponse from "../../model/articleDelivery/ArticleStockResponse";
import AddArticleDeliveryStockRequest from "../../model/articleDelivery/AddArticleDeliveryStockRequest";
import DamagedArticleStockRequest from "../../model/articleDelivery/DamagedArticleStockRequest";

export module ArticleStockService {

    export async function get(page: number = 1, pageSize: number = 15, articleId: string): Promise<Response<PagedResponse<ArticleStockResponse>>> {
        const url = Config.get("GET_ARTICLE_STOCK_URL", {page, pageSize, articleId, entityId: ''});
        const request = new Request(url);
        const response = await RestClient.get(request);
        if (response.success) {
            const stockData = response.data?.data;
            const paginationData = response.data?.pagination;
            if (stockData && paginationData) {
                const data = stockData.map((t: any) => new ArticleStockResponse(
                    t.id,
                    t.agencyId,
                    t.articleId,
                    t.articleName,
                    t.articleDefaultImage,
                    t.entityId,
                    t.entityName,
                    t.unit,
                    t.locationType,
                    t.amount,
                    t.blockedAmount,
                    t.availableAmount,
                    t.assignedAmount,
                    t.damagedAmount
                ));
                const pagination = new Pagination(paginationData.currentPage, paginationData.pageSize, paginationData.elementsCount, paginationData.pageCount);
                return new Response<PagedResponse<ArticleStockResponse>>(true, {data, pagination}, response.error)
            }
        }
        return new Response<PagedResponse<ArticleStockResponse>>(false, undefined, response.error, response.status);
    }

    export async function getFromEntity(page: number = 1, pageSize: number = 15, entityId?: string, articleId?: string): Promise<Response<PagedResponse<ArticleStockResponse>>> {
        const url = Config.get("GET_ARTICLE_STOCK_URL", {page, pageSize, entityId, articleId});
        const request = new Request(url)
        const response = await RestClient.get(request)
        if (response.success) {
            const costData = response.data?.data;
            const paginationData = response.data?.pagination;
            if (costData && paginationData) {
                const data = costData.map((t: any) => new ArticleStockResponse(
                    t.id,
                    t.agencyId,
                    t.articleId,
                    t.articleName,
                    t.articleDefaultImage,
                    t.entityId,
                    t.entityName,
                    t.unit,
                    t.locationType,
                    t.amount,
                    t.blockedAmount,
                    t.availableAmount,
                    t.assignedAmount,
                    t.damagedAmount
                ));
                const pagination = new Pagination(paginationData.currentPage, paginationData.pageSize, paginationData.elementsCount, paginationData.pageCount);
                return new Response<PagedResponse<ArticleStockResponse>>(true, {data, pagination}, response.error)
            }
        }
        return new Response<PagedResponse<ArticleStockResponse>>(false, undefined, response.error, response.status);
    }

    export async function addArticleStock(request: AddArticleDeliveryStockRequest): Promise<Response<any>> {
        const url = Config.get("ADD_ARTICLE_STOCK_URL", {});
        const requestToSend = new Request(url, request);
        return await RestClient.post(requestToSend);
    }

    export async function markDamagedArticleStock(request: DamagedArticleStockRequest): Promise<Response<any>> {
        const url = Config.get("MARK_DAMAGED_ARTICLE_STOCK_URL", {});
        const requestToSend = new Request(url, request);
        return await RestClient.post(requestToSend);
    }

    export async function collectDamagedArticleStock(request: DamagedArticleStockRequest): Promise<Response<any>> {
        const url = Config.get("COLLECT_DAMAGED_ARTICLE_STOCK_URL", {});
        const requestToSend = new Request(url, request);
        return await RestClient.post(requestToSend);
    }

    export async function getAssignedArticleStockAmount(articleId: string): Promise<Response<number>> {
        const url = Config.get("GET_ASSIGNED_ARTICLE_STOCK_AMOUNT_URL", {id: articleId});
        const request = new Request(url)
        const response = await RestClient.get(request)
        if (response.success) {
            return new Response<number>(true, response.data, response.error, response.status);
        }
        return new Response<number>(false, undefined, response.error, response.status);
    }

}